<template>
    <div v-show="showSuccess">
        <div class=header>
            <header-tag :title="title"></header-tag>
        </div>
        <div class="form-body">
            <div class="left">
                <img src="@/assets/img/icon/u3313.png" alt="">
            </div>
            <div class="right">
                <div v-text="msg"></div>
                <div v-text="msgTwo"></div>
            </div>
        </div>
        <div class="footer">
            <button @click.prevent="closePwd">前往登录</button>
        </div>
    </div>
</template>
<script>
import HeaderTag from '_c/tagTitle/headerTag'
import PAGE_API from '@/apis/pageApi'
export default {
    name: 'changePwd',
    components:{
        HeaderTag,
    },
    props:{
        showSuccess:{
            type:Boolean,
            default:false
        },
        msg:{
            type: String,
            default: ''
        },
        msgTwo:{
            type: String,
            default: ''
        },
        title:{
            type: String,
            default: ''
        },

    },
    data(){
        return {
            show: true,
            count: '',
            timer: null,
        }
    },
    methods:{
        //关闭修改密码弹框
        closePwd(){
            this.$router.push({
                path: PAGE_API.login.path
            })
        },
        showImgModals(data){
            this.showImg = data
        }
    },
    watch:{
        showSuccess: function(){
            setTimeout(() => {
                this.closePwd()
            },5000)
        }
    }
}
</script>
<style lang="scss" scoped>
.header {
    padding-left: 30px;
    text-align: left;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #d9dee4;
}
.footer{
    margin-top: 20px;
    padding: 10px 0;
    margin-left: 5%;
    width: 90%;
    text-align: right;
    border-top: 1px solid #d9dee4;
    button{
        width: 100px;
        line-height: 30px;
        background-color: rgb(0, 153, 204);
        border: 1px solid rgb(0, 153, 204);
        color: #fff;
    }
}
.form-body{
    overflow: hidden;
    width: 100%;
    padding: 15px 0px 10px 0px;
    line-height: 30px;
    .left{
        float: left;
        width: 90px;
        height: 100%;
        img{
            float: right;
            margin-top: 3px;
        }
    }
    .right{
        float: left;
        padding-left: 10px;
        width: 300px;
        height: 100%;
        text-align: left;
        font-size: 14px;
        div{
            width: 100%;
            white-space:normal;
            word-break:break-all;
            word-wrap:break-word;
        }
    }
}
</style>